import { BillingMethodsEnum } from '../enums/team-task-billing-methods.enum';
import { BudgetTypes } from '../enums/team-task-budgets.enum';

export const Budgets = [
  { name: 'No budget selected', id: BudgetTypes.NO_BUDGET_SELECTED },
  {
    name: 'Total budget and hours per task',
    id: BudgetTypes.TOTAL_BUDGET_AND_HOURS_PER_TASK,
  },
  { name: 'Total project hours', id: BudgetTypes.TOTAL_PROJECT_HOURS },
  { name: 'Total project fees', id: BudgetTypes.TOTAL_PROJECT_FEES },
  { name: 'Hours per task', id: BudgetTypes.HOURS_PER_TASK },
  { name: 'Hours per person', id: BudgetTypes.HOURS_PER_PERSON },
  { name: 'Fees per task', id: BudgetTypes.FEES_PER_TASK },
];

export const BillingMethods = [
  {
    name: 'No billing method selected',
    id: BillingMethodsEnum.NO_BILLING_METHOD_SELECTED,
  },
  { name: 'Project hourly rate', id: BillingMethodsEnum.PROJECT_HOURLY_RATE },
  { name: 'Person hourly rate', id: BillingMethodsEnum.PERSON_HOURLY_RATE },
  { name: 'Task hourly rate', id: BillingMethodsEnum.TASK_HOURLY_RATE },
];

export const NonBillableBudgets = [
  { name: 'No budget selected', id: BudgetTypes.NO_BUDGET_SELECTED },
  { name: 'Total project hours', id: BudgetTypes.TOTAL_PROJECT_HOURS },
  { name: 'Hours per task', id: BudgetTypes.HOURS_PER_TASK },
  { name: 'Hours per person', id: BudgetTypes.HOURS_PER_PERSON },
];
